import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxUser from "../../util/remote/ajaxUser";

const AddFloat=(props)=>{

    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState("")

    const data = {
        vendor_user_id: props.accountID,
        amount: amount     
    };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(amount >0){
            setLoading(true)
            const server_response = await ajaxUser.loadFloat(data);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                setAmount("")
                props.g()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Enter an amount to be deposited as float!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                <button 
                    type="button" 
                    className={`btn-fill-md text-light bg-dodger-blue`} 
                    onClick={handleUpdate}>Deposit<i class="fas fa-check mg-l-15"></i>
                </button>
            </>
        }
    }

    return(
        <SystemModal
            title="Load Virtual Float"
            id="model-load-float"
            size="md"
            footer={RenderFooter}
        >
            <div className="row">
                <div className="mb-4 col-12 form-group">
                <label htmlFor="">Amount <span style={{color:"red"}}>*</span></label>
                <input onChange={(e)=>setAmount(e.target.value)} placeholder="Enter amount to be loaded as float..." style={{border: "1px solid grey"}} value={amount} type="text" className="form-control"/>
                </div>
            </div>
       
        </SystemModal>
    )
}

export default AddFloat
